export const USE_MOCK = false;
export const API_URL = import.meta.env.VITE_API_URL || '';
export const WS_URL = import.meta.env.VITE_WS_URL || '';
export const HARDWARE_AGENT_URL = import.meta.env.VITE_HARDWARE_AGENT_URL || '';
// EG-82/83/84 — Hardware agent định danh thiết bị qua `device_id` trong path
// `/api/v1/{kind}s/{device_id}/...`. Agent registry dùng:
//   - scale: 'default'
//   - printer: 'receipt' (máy in nhiệt POS) | 'label' (máy in tem)
//   - nfc: 'default'
export const HARDWARE_DEFAULT_SCALE_ID =
  import.meta.env.VITE_HARDWARE_DEFAULT_SCALE_ID || 'default';
export const HARDWARE_RECEIPT_PRINTER_ID =
  import.meta.env.VITE_HARDWARE_RECEIPT_PRINTER_ID || 'receipt';
export const HARDWARE_LABEL_PRINTER_ID =
  import.meta.env.VITE_HARDWARE_LABEL_PRINTER_ID || 'label';
/** @deprecated Dùng HARDWARE_RECEIPT_PRINTER_ID / HARDWARE_LABEL_PRINTER_ID. */
export const HARDWARE_DEFAULT_PRINTER_ID = HARDWARE_RECEIPT_PRINTER_ID;
export const HARDWARE_DEFAULT_NFC_ID =
  import.meta.env.VITE_HARDWARE_DEFAULT_NFC_ID || 'default';
export const GOLD_PRICE_POLL_INTERVAL = Number(
  import.meta.env.VITE_GOLD_PRICE_POLL_INTERVAL ?? 5000,
);
